module.exports = __webpack_public_path__ + "static/media/15b-06_ST-2015-200x300cm-oleo-sobre-papel.58f05d80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15b/15b-06_ST-2015-200x300cm-oleo-sobre-papel.jpg
// module id = 162
// module chunks = 0